import { BACKEND_PRIVATE, BACKEND_PUBLIC } from './base'
import { Roles } from '@/constants/user/roles'

export async function getUserInfo() {
  return BACKEND_PRIVATE.get('/users/info')
}

export async function getActiveProfile() {
  return BACKEND_PRIVATE.get('/me/profiles/get-active-profile')
}

export async function getMyFreelancerProfile() {
  return BACKEND_PRIVATE.get('/me/profiles/freelancer/get-profile')
}

export async function getMyCustomerProfile() {
  return BACKEND_PRIVATE.get('/me/profiles/customer/get-profile')
}

export async function saveMyGeneralFreelancerProfile(payload: any) {
  return BACKEND_PRIVATE.post('/me/profiles/freelancer/save-general-info', { payload })
}

export async function saveMyGeneralCustomerProfile(payload: any) {
  return BACKEND_PRIVATE.post('/me/profiles/customer/save-general-info', { payload })
}

export async function saveMyWorkExperienceProfile(payload: any) {
  return BACKEND_PRIVATE.post('/me/profiles/freelancer/upsert-work-experience', { payload })
}

export async function saveEducationsProfile(payload: any) {
  return BACKEND_PRIVATE.post('/me/profiles/freelancer/upsert-education', { payload })
}

export async function saveMyFreelancerInfoProfile(payload: any) {
  return BACKEND_PRIVATE.post('/me/profiles/freelancer/save-freelance-info', { payload })
}

export async function saveMyFullTimeInfoProfile(payload: any) {
  return BACKEND_PRIVATE.post('/me/profiles/freelancer/save-full-time-info', { payload })
}

export async function saveFreelancerChannelsProfile(payload: any) {
  return BACKEND_PRIVATE.post('/me/profiles/freelancer/upsert-socials', { payload })
}

export async function saveFreelancerPortfolioProfile(payload: any) {
  return BACKEND_PRIVATE.post('/me/profiles/freelancer/upsert-portfolio', { payload })
}

export async function saveCustomerChannelsProfile(payload: any) {
  return BACKEND_PRIVATE.post('/me/profiles/customer/upsert-socials', { payload })
}

export async function saveCustomerIndividualInfoProfile(payload: any) {
  return BACKEND_PRIVATE.post('/me/profiles/customer/save-individual-info', { payload })
}

export async function saveCustomerCompanyInfoProfile(payload: any) {
  return BACKEND_PRIVATE.post('/me/profiles/customer/save-company-info', { payload })
}

export async function updateGeneralInfo(payload: any) {
  return BACKEND_PRIVATE.put('/me/profiles/save-active-profile', { payload })
}

export async function switchRole(type: Roles) {
  return BACKEND_PRIVATE.post('/me/users/switch-role', { payload: { type } })
}

export async function addRole(payload: any) {
  return BACKEND_PRIVATE.post('/me/users/add-role', { payload })
}

export const uploadAvatar = async ({ x, y, w, h, avatar }: { x: number; y: number; w: number; h: number; avatar: any }) => {
  const formData = new FormData()
  formData.append('avatar', avatar)
  formData.append('x', String(x))
  formData.append('y', String(y))
  formData.append('w', String(w))
  formData.append('h', String(h))
  return BACKEND_PRIVATE.post('/me/profiles/upload-avatar', formData)
}

export const removeAvatar = async () => {
  return BACKEND_PRIVATE.delete('/me/profiles/remove-avatar')
}

export async function changePassword({ oldPassword, newPassword, key }: { oldPassword: string; newPassword: string; key?: string }) {
  return BACKEND_PRIVATE.post('/users/change-password', {
    payload: {
      oldPassword,
      newPassword,
      newPasswordConfirm: newPassword,
      key,
    },
  })
}

export async function get2FASecret() {
  return BACKEND_PRIVATE.get('/users/generate-2fa')
}

export async function enable2FA(key: string, secret: string) {
  return BACKEND_PRIVATE.post('/users/enable-2fa', { payload: { key, secret } })
}

export async function disable2FA(key: string) {
  return BACKEND_PRIVATE.post('/users/disable-2fa', { payload: { key } })
}

export async function changeEmailRequest({ email, key }: { email: string; key?: string }) {
  return BACKEND_PRIVATE.post('/users/request-email-change', { payload: { email, key } })
}

export function confirmEmail(token: string) {
  return BACKEND_PUBLIC.post('/users/confirm-email-change', {
    payload: {
      token,
    },
  })
}

export async function disableMmAddEmail() {
  return BACKEND_PRIVATE.post('/me/users/disable-mm-add-email')
}

export async function deleteUser(payload: any) {
  return BACKEND_PRIVATE.post('/me/users/remove', { payload })
}

export async function getActiveRole() {
  return BACKEND_PRIVATE.get('/me/init')
}

export async function userUpdateMeta(token: string) {
  return BACKEND_PUBLIC.get('/users/update-meta', { params: { token } })
}
